import React, { useState } from "react"
import DescargarDocumentos from "./DescargarDocumentos"
import TableCustom from "../../components/TableCustom"
import Vista from "../../components/Vista"
import dateComponent from "../../components/dateComponent"

const busquedaDefault = {
  placas: "",
  fechaInicio: dateComponent.getFirstDayOfYear(),
  fechaFinal: dateComponent.getActualDay()
}

let dataTable = {
  placas: {
    nombre: "Placas",
    content: (e) => {
      return e.placas
    }
  },
  economico: {
    nombre: "Numero Económico",
    content: (e) => {
      return e.economico
    }
  },
  datos: {
    nombre: "Datos",
    content: (e) => {
      return e.marca + " " + e.modelo + " " + e.year
    }
  },
  documentos: {
    nombre: "Archivos",
    content: carro => <DescargarDocumentos carro={carro} />
  }
}

let dataPdf = {
  placas: {
    nombre: "Placas",
    content: (e) => {
      return e.placas
    }
  },
  economico: {
    nombre: "Numero Económico",
    content: (e) => {
      return e.economico
    }
  },
  datos: {
    nombre: "Datos",
    content: (e) => {
      return e.marca + " " + e.modelo + " " + e.year
    }
  }
}

const Carro = ({ onClick, onKeyDown, ...props }) => {
  const [busqueda, setBusqueda] = useState({ ...busquedaDefault })

  return (
    <Vista>
      <TableCustom
        tipo={"idCarro"}
        expand="archivos"
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        dataTable={dataTable}
        dataPdf={dataPdf}
        permisoCheck={"carros"}
        nombreBusqueda={["economico", "placas", "vin"]}
      />
    </Vista>
  )
}

export default Carro
